export var PreferredContactMethod;
(function (PreferredContactMethod) {
    PreferredContactMethod["EMAIL"] = "email";
    PreferredContactMethod["PHONE"] = "phone";
})(PreferredContactMethod || (PreferredContactMethod = {}));
